import { render, staticRenderFns } from "./FormProfil.vue?vue&type=template&id=22d433fe"
import script from "./FormProfil.vue?vue&type=script&lang=js"
export * from "./FormProfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports